<template>
  <svg :width="width" :height="height" viewBox="0 0 26 16" :fill="color" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 0C1.79086 0 0 1.79086 0 4V12C0 14.2091 1.79086 16 4 16H14C16.2091 16 18 14.2091 18 12V10.8462L24.74 12.6608C25.3754 12.8318 26 12.3532 26 11.6952V4.30484C26 3.64682 25.3754 3.16815 24.74 3.33922L18 5.15385V4C18 1.79086 16.2091 0 14 0H4Z" fill="#80B7FF"/>
  </svg>
</template>

<script>
import {colors} from "../../constants";

export default {
  props: {
    width: { type: [Number, String], default: 16 },
    height: { type: [Number, String], default: 14 },
    color: { type: String, default: colors.iconColor }
  },
  name: "IconVideoConference"
}
</script>